function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default ({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M8 0a5.86 5.86 0 016 5.71c0 2-1.74 5.26-5.23 9.9a1 1 0 01-1.36.19.81.81 0 01-.18-.19C3.74 11 2 7.72 2 5.71A5.86 5.86 0 018 0zm0 1.94A4.17 4.17 0 003.7 6c0 1.44 1.44 4.14 4.3 8 2.86-3.84 4.3-6.54 4.3-8A4.17 4.17 0 008 1.94zM8 3.5a2.63 2.63 0 012.52 2.71A2.63 2.63 0 018 8.93a2.63 2.63 0 01-2.52-2.72A2.63 2.63 0 018 3.5zm0 1.26a1.4 1.4 0 00-1.35 1.45A1.4 1.4 0 008 7.67a1.4 1.4 0 001.35-1.46A1.4 1.4 0 008 4.76z"
}));